import React, { useState, useEffect } from "react";
import TextInputNoLabel from "../../../ShareElements/TextInput/TextInputNolabel";
import Switch from "../../../ShareElements/TextInput/Switch";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../../Config";
import DesktopOnlyOverlay from "../../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import TextAreaNoLabel from "../../../ShareElements/TextInput/TextAreaNolabel";

const BasicSettings = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const [ChangesApplied, setChangesApplied] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [ValidationText, setValidationText] = useState(
    translateText("specify_acl_name_error") + "."
  );
  const [CreateIsDone, setCreateIsDone] = useState(false);
  const [CreatedACLId, setCreatedACLId] = useState("");
  const [CreatedACLname, setACLname] = useState(
    window.localStorage.getItem("CreatedACLName")
  );
  const [ACLisActive, setACLisActive] = useState(true);
  const [IncludeAll, setIncludeAll] = useState(true);
  const [IncludeOwn, setIncludeOwn] = useState(true);
  const [IncludeUnAssigned, setIncludeUnassigned] = useState(true);

  useEffect(() => {
    window.localStorage.setItem("LastIdClicked", "");
    if (window.localStorage.getItem("BasicSettingsCreated") === "1") {
      getPreviousSettings();
      setCreateIsDone(true);
    }
  }, []);

  const getPreviousSettings = () => {
    document.getElementById("name").value =
      window.localStorage.getItem("CreatedACLName");
    document.getElementById("description").value =
      window.localStorage.getItem("CreatedACLDesc");

    if (window.localStorage.getItem("Enabled") === "false") {
      setACLisActive(false);
    } else {
      setACLisActive(true);
    }

    if (window.localStorage.getItem("IncludeAllRecords") === "false") {
      setIncludeAll(false);
    } else {
      setIncludeAll(true);
    }

    if (window.localStorage.getItem("IncludeOwnRecords") === "false") {
      setIncludeOwn(false);
    } else {
      setIncludeOwn(true);
    }

    if (window.localStorage.getItem("IncludeUnAssigned") === "false") {
      setIncludeUnassigned(false);
    } else {
      setIncludeUnassigned(true);
    }
  };

  const handleInputChange = () => {
    enableSave();
  };
  const handleSwitchChange = (Id) => {
    enableSave();
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedACLId");
      window.localStorage.removeItem("MappingCreated");
      window.localStorage.removeItem("CreatedACLName");
      window.localStorage.removeItem("BasicSettingsCreated");
      window.localStorage.removeItem("HasUnsaveChanges");
      window.location.assign("/home/acls");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/acls");
  };
  const validateEntries = () => {
    let Name = document.getElementById("name").value;
    let Description = document.getElementById("description").value;
    if (Name.length <= 0) {
      setValidationText("Please specify the ACL name.");
      showEmptyNameError();
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else {
      if (CreateIsDone) {
        editCreatedProfile();
      } else {
        createProfile(Name, Description);
      }
    }
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    if (document.getElementById("name-label-holder").classList.length < 2) {
      if (window.localStorage.getItem("LastIdClicked").length > 0) {
        validateEntries();
      } else {
        validateEntries();
        setTimeout(() => {
          if (
            document.getElementById("name-label-holder").classList.length < 2
          ) {
            window.location.assign("/home/acls");
          } else {
            return null;
          }
        }, 1500);
      }
    }
  };
  const showEmptyNameError = () => {
    document.getElementById("name-label-holder").classList.add("wrong");
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const createProfile = (Name, Description) => {
    let ProfileInfo = {
      description: Description,
      name: Name,
    };

    if (document.getElementById("status-switch-holder").classList.length > 1) {
      ProfileInfo.enabled = false;
    } else {
      ProfileInfo.enabled = true;
    }
    if (
      document.getElementById("all-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeAllRecords = false;
    } else {
      ProfileInfo.includeAllRecords = true;
    }
    if (
      document.getElementById("unassigned-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeUnAssigned = false;
    } else {
      ProfileInfo.includeUnAssigned = true;
    }
    if (
      document.getElementById("own-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeRequester = false;
    } else {
      ProfileInfo.includeRequester = true;
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: ProfileInfo,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("CreatedACLId", Res.data.id);
        setCreatedACLId(Res.data.id);
        disableSaveBtn();
        setACLname(Name);
        setCreateIsDone(true); // any changes after this is set to true is handled as an edit to the created acl
        window.localStorage.setItem("CreatedACLName", Name);
        window.localStorage.setItem("BasicSettingsCreated", 1); // 1 means true, 0 means false
        window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
        window.localStorage.setItem("CreatedACLDesc", Description);
        window.localStorage.setItem("Enabled", Res.data.enabled);
        window.localStorage.setItem(
          "IncludeAllRecords",
          Res.data.includeAllRecords
        );
        window.localStorage.setItem(
          "IncludeUnAssigned",
          Res.data.includeUnAssigned
        );
        window.localStorage.setItem(
          "IncludeOwnRecords",
          Res.data.includeRequester
        );
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 409) {
          setValidationText("An ACL with this name already exists.");
          showEmptyNameError();
        }
      });
  };
  const editCreatedProfile = () => {
    let ProfileInfo = {
      description: document.getElementById("description").value,
      name: document.getElementById("name").value,
      id: window.localStorage.getItem("CreatedACLId"),
    };
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      ProfileInfo.enabled = false;
    } else {
      ProfileInfo.enabled = true;
    }
    if (
      document.getElementById("all-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeAllRecords = false;
    } else {
      ProfileInfo.includeAllRecords = true;
    }
    if (
      document.getElementById("unassigned-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeUnAssigned = false;
    } else {
      ProfileInfo.includeUnAssigned = true;
    }
    if (
      document.getElementById("own-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeRequester = false;
    } else {
      ProfileInfo.includeRequester = true;
    }
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: ProfileInfo,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        disableSaveBtn();
        window.localStorage.setItem("CreatedACLName", Res.data.name);
        setACLname(Res.data.name);
        window.localStorage.setItem("CreatedACLDesc", Res.data.description);
        window.localStorage.setItem("Enabled", Res.data.enabled);
        window.localStorage.setItem(
          "IncludeAllRecords",
          Res.data.includeAllRecords
        );
        window.localStorage.setItem(
          "IncludeUnAssigned",
          Res.data.includeUnAssigned
        );
        window.localStorage.setItem(
          "IncludeOwnRecords",
          Res.data.includeRequester
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  return (
    <div className="acl-edit-form">
      <DesktopOnlyOverlay LangData={props.LangData} />
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => closeAlert()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {CreatedACLname === null ? (
            <h1>{translateText("new_acl")}</h1>
          ) : (
            <h1>{CreatedACLname}</h1>
          )}
          <div className="action-btn-group">
            <button onClick={() => cancelOperation()} className="cancel">
              {translateText("cancel")}
            </button>
            <button
              onClick={() => validateEntries()}
              id="save-btn"
              className="save disabled"
            >
              {translateText("save")}
            </button>
          </div>
        </section>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("general_info")}</h1>
          </div>
        </section>
        <div className="row">
          <p className="name">
            {translateText("name")} <p className="required">*</p>
          </p>
          <TextInputNoLabel
            ChangeEvent={() => handleInputChange()}
            Id="name"
            PlaceHolder={translateText("acl_name")}
            ValidationMessage={ValidationText}
          />
        </div>
        <div className="row">
          <p className="name">{translateText("status")}</p>
          {window.localStorage.getItem("BasicSettingsCreated") === "1" ? (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              IsActive={ACLisActive}
            />
          ) : (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              IsActive={true}
            />
          )}
        </div>
        <div className="row">
          <p className="name float-top">{translateText("description")}</p>
          <TextAreaNoLabel
            ChangeEvent={() => handleInputChange()}
            Id="description"
            PlaceHolder={translateText("optional")}
            ValidationMessage="Please, fill the field."
          />
        </div>
        <div className="separator with-margin"></div>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("access_settings")}</h1>
          </div>
        </section>
        <div className="row">
          <section className="field-description">
            <div className="with-info">
              <React.Fragment></React.Fragment>
              <p className="name field-name">
                {translateText("include_all_records")}
              </p>
              <button>
                <i className="feather-alert-circle"></i>
                <section className="dialogue-body">
                  <p>{translateText("add_acl_info_button_text")}</p>
                </section>
              </button>
              {window.localStorage.getItem("BasicSettingsCreated") === "1" ? (
                <Switch
                  ChangeEvent={() => handleSwitchChange("all-records")}
                  Id="all-records"
                  IsActive={IncludeAll}
                />
              ) : (
                <Switch
                  ChangeEvent={() => handleSwitchChange("all-records")}
                  Id="all-records"
                  IsActive={true}
                />
              )}
            </div>
            <p className="info">{translateText("all_records_info")}.</p>
          </section>
        </div>
        <div className="row">
          <section className="field-description">
            <p className="name field-name">
              {translateText("include_unassigned")}
            </p>
            <p className="info long-info">
              {translateText("unassigned_info")}.
            </p>
          </section>
          {window.localStorage.getItem("BasicSettingsCreated") === "1" ? (
            <Switch
              ChangeEvent={() => handleSwitchChange("unassigned")}
              Id="unassigned"
              IsActive={IncludeUnAssigned}
            />
          ) : (
            <Switch
              ChangeEvent={() => handleSwitchChange("unassigned")}
              Id="unassigned"
              IsActive={true}
            />
          )}
        </div>
        <div className="row">
          <section className="field-description">
            <p className="name field-name">
              {translateText("include_own_records")}
            </p>
            <p className="info">{translateText("own_records_info")}.</p>
          </section>
          {window.localStorage.getItem("BasicSettingsCreated") === "1" ? (
            <Switch
              ChangeEvent={() => handleSwitchChange("own-records")}
              Id="own-records"
              IsActive={IncludeOwn}
            />
          ) : (
            <Switch
              ChangeEvent={() => handleSwitchChange("own-records")}
              Id="own-records"
              IsActive={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicSettings;
